/* eslint-disable @typescript-eslint/naming-convention */
import type { Reference, TilesGrid } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSPageSection } from '@swf/cms';

import styles from '../../styles/styles.scss';

import TilesGridItem from './TilesGridItem';

const CMSTilesGrid: React.FC<TilesGrid> = ({
  heading,
  intro,
  items,
  number_of_columns = 3,
  item_alignment
}) => (
  <CMSPageSection
    heading={heading}
    intro={intro}
    grid
    columns={number_of_columns}
    className={styles[item_alignment || '']}
  >
    {!!items.length &&
      items.map((item: Reference, index) => <TilesGridItem key={index} {...item} />)}
  </CMSPageSection>
);

export default CMSTilesGrid;
